import React from 'react';

const SvgShippingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M9.333 12V4a1.333 1.333 0 0 0 -1.333 -1.333H2.667a1.333 1.333 0 0 0 -1.333 1.333v7.333a0.667 0.667 0 0 0 0.667 0.667h1.333" />
        <path d="M10 12H6" />
        <path d="M12.667 12h1.333a0.667 0.667 0 0 0 0.667 -0.667v-2.433a0.667 0.667 0 0 0 -0.147 -0.416l-2.32 -2.9A0.667 0.667 0 0 0 11.68 5.333H9.333" />
        <path
            cx={17}
            cy={18}
            r={2}
            d="M12.667 12A1.333 1.333 0 0 1 11.333 13.333A1.333 1.333 0 0 1 10 12A1.333 1.333 0 0 1 12.667 12z"
        />
        <path
            cx={7}
            cy={18}
            r={2}
            d="M6 12A1.333 1.333 0 0 1 4.667 13.333A1.333 1.333 0 0 1 3.333 12A1.333 1.333 0 0 1 6 12z"
        />
    </svg>
);

export default SvgShippingIcon;